
import { Options, Vue } from 'vue-class-component'
import draggable from 'vuedraggable'
import { Prop, Watch } from 'vue-property-decorator'
import { IFormLIFFDetail } from '@/utils/types'
import { maska } from 'maska'
import { calcOrderingDragend } from '@/utils/helpers'
import { FORM_LIFF_TYPE } from '@/utils/constants'
import FormLIFFOption from '@/components/form/FormLIFFOption.vue'

@Options({
  components: { FormLIFFOption, draggable },
  directives: { maska },
  emits: ['update:modelValue', 'update:quantityItem'],
})
export default class FormLIFFField extends Vue {
  @Prop({ default: [] })
  modelValue!: IFormLIFFDetail[]

  @Prop()
  isDeleteFirst!: boolean

  countAnswer = 0
  field_index = 0

  get value() {
    return this.modelValue
  }

  set value(value: IFormLIFFDetail[]) {
    this.$emit('update:modelValue', value)
  }

  get options() {
    return [
      {
        id: FORM_LIFF_TYPE.TEXT,
        title: this.$t('label.common.form_liff.type_text'),
      },
      {
        id: FORM_LIFF_TYPE.TEXTAREA,
        title: this.$t('label.common.form_liff.type_textarea'),
      },
      {
        id: FORM_LIFF_TYPE.EMAIL,
        title: this.$t('label.common.form_liff.type_email'),
      },
      {
        id: FORM_LIFF_TYPE.SELECT,
        title: this.$t('label.common.form_liff.type_select'),
      },
      {
        id: FORM_LIFF_TYPE.CHECKBOX,
        title: this.$t('label.common.form_liff.type_checkbox'),
      },
      {
        id: FORM_LIFF_TYPE.RADIO,
        title: this.$t('label.common.form_liff.type_radio'),
      },
      {
        id: FORM_LIFF_TYPE.DATE,
        title: this.$t('label.common.form_liff.type_date'),
      },
      {
        id: FORM_LIFF_TYPE.PREFECTURE,
        title: this.$t('label.common.form_liff.type_prefecture'),
      },
      {
        id: FORM_LIFF_TYPE.POSTCODE,
        title: this.$t('label.common.form_liff.type_postcode'),
      },
      {
        id: FORM_LIFF_TYPE.PHONE_NUMBER,
        title: this.$t('label.common.form_liff.type_phone_number'),
      },
      {
        id: FORM_LIFF_TYPE.TIME,
        title: this.$t('label.common.form_liff.type_time'),
      },
    ]
  }

  get requiredRule() {
    return {
      fieldName: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.form.field_name'),
      }),
      freeTextOption: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.common.answer.freetext_option_type'),
      }),
    }
  }

  async onDragEnd(evt: any, finalList: IFormLIFFDetail[]) {
    if (!evt.moved) {
      return
    }

    const record = evt.moved.element
    calcOrderingDragend(record, finalList)
  }

  onHandleField(index) {
    this.field_index = index
  }

  onSelectedFieldType() {
    const field = this.value[this.field_index]
    if (field) {
      this.handleOptionChange(field)
    }
  }

  handleOptionChange(field) {
    const existingDescription = field.contents?.description || ''

    if (field.option_type === FORM_LIFF_TYPE.TEXT) {
      field.contents = {
        short_answer: '',
        description: existingDescription,
      }
    } else if (field.option_type === FORM_LIFF_TYPE.TEXTAREA) {
      field.contents = {
        long_answer: '',
        description: existingDescription,
      }
    } else if (field.option_type === FORM_LIFF_TYPE.EMAIL) {
      field.contents = {
        email: '',
        description: existingDescription,
      }
    } else if (field.option_type === FORM_LIFF_TYPE.DATE) {
      field.contents = {
        date: '',
        description: existingDescription,
      }
    } else if (field.option_type === FORM_LIFF_TYPE.TIME) {
      field.contents = {
        time: '',
        description: existingDescription,
      }
    } else if (field.option_type === FORM_LIFF_TYPE.PREFECTURE) {
      field.contents = {
        prefecture: '',
        description: existingDescription,
      }
    } else if (field.option_type === FORM_LIFF_TYPE.POSTCODE) {
      field.contents = {
        postcode: '',
        is_hyphenated: true,
        description: existingDescription,
      }
    } else if (field.option_type === FORM_LIFF_TYPE.PHONE_NUMBER) {
      field.contents = {
        phone_number: '',
        is_hyphenated: true,
        description: existingDescription,
      }
    } else if (
      field.option_type === FORM_LIFF_TYPE.SELECT ||
      field.option_type === FORM_LIFF_TYPE.CHECKBOX ||
      field.option_type === FORM_LIFF_TYPE.RADIO
    ) {
      field.contents = {
        options: [],
        description: existingDescription,
      }
    }
  }

  handleAddAnswer(index: number): void {
    const newAnser: IFormLIFFDetail = {
      _id: '',
      field_name: this.$t('label.common.form_liff.question'),
      option_type: FORM_LIFF_TYPE.TEXT,
      is_required: true,
      contents: {
        short_answer: '',
        description: '',
      },
    }
    if (this.value) {
      this.value.splice(index + 1, 0, newAnser)
      this.countAnswer = index + 1
    }
    if (this.value.length === 1) {
      this.$emit('update:quantityItem', this.value.length)
    }
  }

  handleDeleteAnswer(index: number): void {
    if (this.value) {
      this.value.splice(index, 1)
      this.countAnswer = index - 1
    }

    if (this.value.length === 0) {
      this.$emit('update:quantityItem', this.value.length)
    }
  }

  @Watch('modelValue', { immediate: true })
  showDefault() {
    if (this.value.length === 0) {
      this.handleAddAnswer(0)
    }
  }

  mounted() {
    this.showDefault()
  }
}
